import React from "react";
import profile from "../../assets/uicon.png";
import '../../css/homepage.css'

const Admin = ({ values }) => {
  return (
    <div className="bg-transparent">
      <div>
        <p className="text-3xl font-semibold ml-20 pb-10 title">Admin Panel</p>
      </div>
      <div className="flex">
        <div className="flex lg:ml-20 ml-4 lg:space-x-3 w-fit my-10 bg-[#434242] items-center text-sm shadow-inner py-2 px-4 rounded-sm">
          {values?.businessLogoUrl ? (
            <>
              <img
                src={values?.businessLogoUrl}
                alt="profile"
                className="w-20 h-20"
              />
            </>
          ) : (
            <img src={profile} alt="profile" className="w-20 h-20" />
          )}
        </div>
        <button className="flex mx-10 my-20 text-black bg-[#22f4fa]/60 justify-center items-center w-fit cursor-pointer p-3 font-medium text-center rounded-3xl text-sm">Change company logo</button>
      </div>
      <div>
        <form className="lg:grid grid-cols-2 gap-10 lg:ml-20 lg:mr-80 px-4">
          <div className="col-span-2">
            <label className="text-sm font-normal py-2 leading-4 text-white">Company Name</label>
            <input type="text" className="py-2 w-full p-2 text-sm" readOnly value={values?.companyName} />
          </div>
          <div className="col-span-1">
            <label className="text-sm font-normal py-2 leading-4 text-white">Company Email</label>
            <input type="text" className="py-2 w-full p-2 text-sm" readOnly value={values?.email} />
          </div>
          <div className="col-span-1">
            <label className="text-sm font-normal py-2 leading-4 text-white">Company Type</label>
            <input type="text" className="py-2 w-full p-2 text-sm" readOnly value={values?.businessType} />
          </div>

          <div className="col-span-2">
            <p className="text-sm font-normal py-2 leading-4 text-white">
              Company Address: {" "}
              <span>{values?.companyAddress + " " + values.selectedCountry}</span>
            </p>
          </div>
          <div className="col-span-1">
            <p className="text-sm font-normal py-2 leading-4 text-white">
              Created at: <span>{values?.createdAt}</span>
            </p>
          </div>
          <div className="col-span-1">
            <p className="text-sm font-normal py-2 leading-4 text-white">
              Phone Number: <span>{values?.telephone}</span>
            </p>
          </div>
          <div className="col-span-1">
            <p className="text-sm font-normal py-2 leading-4 text-white">
              Company Website: <span>{values?.website}</span>
            </p>
          </div>
          <div className="col-span-2">
            <button className="px-4 rounded-sm py-2 my-3 bg-[#22f4fa]/60">Save Changes</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Admin;
